import { useRef } from 'react';

let idCounter = 0;

/**
 * Generates a stable, unique DOM id for the lifetime of a component.
 *
 * React 17 has no built-in `useId`, so this provides a lightweight replacement
 * used to associate form labels/descriptions with their controls and to link
 * dialog titles via `aria-labelledby`.
 *
 * @param prefix - A human-readable prefix for the generated id.
 * @returns A stable id string, e.g. `gmx-input-4`.
 */
export const useStableId = (prefix = 'gmx') => {

    const idRef = useRef<string | null>(null);

    if (idRef.current === null) {

        idCounter += 1;
        idRef.current = `${prefix}-${idCounter}`;

    }

    return idRef.current;

};
